import React from "react";
import {connect} from 'react-redux';
import {updateClientViewPort} from '../../actions/common/commonActions';

class ClientViewPort extends React.Component {
    componentWillMount() {
        window.onresize =  function () {
            this.updateClientViewPort();
        }.bind(this);
    }

    componentDidMount() {
        this.updateClientViewPort();
    }

    updateClientViewPort = () => {
        const visible = {
            isXs: this.isVisible("xs"),
            isSm: this.isVisible("sm"),
            isMd: this.isVisible("md"),
            isLg: this.isVisible("lg")
        };
        if ((this.props.clientViewPort.isXs !== visible.isXs) ||
            (this.props.clientViewPort.isSm !== visible.isSm) ||
            (this.props.clientViewPort.isMd !== visible.isMd) ||
            (this.props.clientViewPort.isLg !== visible.isLg))

            this.props.updateClientViewPort(visible);
    };

    isVisible = (size) => {
        let indicator = document.getElementById(size + "-indicator");
        if (indicator && indicator !== null) {
            const computed = window.getComputedStyle(indicator);
            return computed===null?false:computed.display !== "none";
        }
        return false;
    };

    render() {
        return(
            <div>
                <span id="xs-indicator" className="visible-xs"/>
                <span id="sm-indicator" className="visible-sm"/>
                <span id="md-indicator" className="visible-md"/>
                <span id="lg-indicator" className="visible-lg"/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        clientViewPort: (state.clientViewPort || {})
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateClientViewPort: (visible) => {
            dispatch(updateClientViewPort(visible));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientViewPort);


// WEBPACK FOOTER //
// ./src/containers/common/ClientViewPort.js